import { Layout } from '../../../queries/ats/layout/types';
import { TrackerEvent } from '../../interfaces/tracker-event';
import { SectionItemEventProperties } from '../../interfaces/section-item-event';

export class PromotionPageSeenEvent implements TrackerEvent<SectionItemEventProperties> {
  public name = 'promotion_seen';
  public properties: SectionItemEventProperties;

  constructor(
    item: Layout.SectionItemPage,
    section: Layout.SectionView,
    page: Layout.PageView,
    pattern: Layout.Pattern,
  ) {
    this.properties = {
      content_title: item.slug,
      item_style: pattern,
      item_type: item.type,
      page_slug: page.slug,
      section_slug: section.slug,
      referral_id: item.slug,
    };
  }
}
